import React, { useState } from "react";
import { Newspaper, CalendarDays } from "lucide-react";

import AdmissionModal from "../AdmissionComponents/AdmissionModal/AdmissionModal";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import parse from 'html-react-parser'
import admissionBg from "../../assets/image13.png";
import { media_url } from "../../url";


const NewsEvents = ({eventsList,latestNews,recentNews}) => {
  const [admissionModal, setAdmissionModal] = useState(false);
  
  useEffect(() => {
    if (admissionModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  });
  return (
    <div className="news-events px-6 md:px-[85px] py-10 md:py-[70px]">
      <div className="news-events-header mb-10">
        <h1 className="text-[38px] md:text-[48px] font-bold text-[#021d53] leading-tight">News & Events</h1>
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-2 gap-6">
        <div className="">
          <div className="flex items-center justify-between">
            <h3 className="text-2xl font-bold text-gray-800 mb-2">Latest News</h3>
            <div className="bottom">
              <Link to={"/news-events/news"} className="text-blue-600 text-sm hover:text-blue-800">Read All News</Link>
            </div>
          </div>
          <div className="max-h-[300px] overflow-y-auto">
            {
              recentNews?.length > 0 ? recentNews?.map((news, index) => (
                
                  <div className="flex gap-2 mb-5 px-5 py-2" key={index}>
                    <div className="w-[135px] h-[135px] mr-[15px] bg-red-500">
                     <img src={`${media_url}${news?.thumbnail}`} alt={news?.title} className="w-full h-full object-cover" />
                    </div>
                    <div className="flex flex-col gap-2 justify-between">
                      <Link to={`/news-events/news/${news?.slug}/`} className="text-sm text-black hover:text-[#021d53c1] text-justify leading-snug">
                        {parse(news?.details?.slice(0,150))}...
                      </Link>
                      <p className="text-[#8e8e8e] text-sm text-left">{new Date(news?.date).toDateString()} - {news?.title}</p>
                    </div>
                  </div>
                
              )) : (
                <div className="flex flex-row items-center gap-4 p-5 bg-blue-50/50 rounded-lg border border-blue-100/50 mt-4 group hover:bg-white hover:shadow-md transition-all duration-300">
                  <div className="flex-shrink-0 w-12 h-12 bg-white rounded-lg flex items-center justify-center text-blue-600 shadow-sm group-hover:scale-110 transition-transform">
                    <Newspaper className="w-6 h-6" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 text-base">Quiet For Now</h4>
                    <p className="text-gray-500 text-xs">No news added yet. Keep an eye out!</p>
                  </div>
                </div>
              )
            }
          </div>
          
        </div>
        <div className="events">
          <div className="events-content">
            <div className="title flex items-end gap-[15px] mb-8">
              <h3 className="text-[23px] font-bold">Upcoming Events</h3>
              <div className="bar h-[6px] w-[93px] bg-[#fb8500] mb-[7px]"></div>
            </div>
            <div className="event-list flex flex-col gap-[30px]">
              {eventsList.map((event, index) => (
                <div key={index} className="event-item flex gap-5 w-full md:w-[75%]">
                  <div className="date flex-1 flex flex-col items-start justify-start">
                    <h3 className="day text-[40px] font-bold text-[#021d53] -ml-[2px] leading-none">{event.day}</h3>
                    <h3 className="month text-base text-[#110E0E80] font-bold uppercase">{event.month}</h3>
                    <h3>{event.year}</h3>
                    <div className="date-underline mt-[5px] h-[3px] w-[33px] bg-[#fb8500]"></div>
                  </div>
                  <div className="event-details flex-[4] mt-[7px]">
                    <div className="event-title">
                      <h3 className="font-bold text-[15px] text-[#021d53]">{event.title}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {
              eventsList.length <= 0 && (
                <div className="flex flex-row items-center gap-4 p-5 bg-blue-50/50 rounded-lg border border-blue-100/50 mt-4 group hover:bg-white hover:shadow-md transition-all duration-300">
                  <div className="flex-shrink-0 w-12 h-12 bg-white rounded-lg flex items-center justify-center text-blue-600 shadow-sm group-hover:scale-110 transition-transform">
                    <CalendarDays className="w-6 h-6" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 text-base">Quiet For Now</h4>
                    <p className="text-gray-500 text-xs">No upcoming events scheduled. Keep an eye out!</p>
                  </div>
                </div>
              )
            }
          </div>
        </div>
        <div 
          className="admission-apply bg-[#021d53c1] bg-no-repeat bg-cover bg-center bg-blend-overlay flex-1"
          style={{ backgroundImage: `url(${admissionBg})` }}
        >
          <div className="admission-content flex flex-col justify-center gap-[50px] p-[40px] md:p-[70px]">
            <h2 className="apply-title text-[35px] md:text-[47.78px] font-bold text-white leading-tight">Apply For Admission</h2>
            {admissionModal && (
              <AdmissionModal
                admissionModal={admissionModal}
                setAdmissionModal={setAdmissionModal}
              />
            )}
            <div
              className="classic-button cursor-pointer inline-block w-fit px-8 py-3 bg-[#fb8500] text-white font-bold rounded hover:bg-[#ffb703] transition-colors"
              onClick={() => setAdmissionModal(!admissionModal)}
            >
              Apply Now
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsEvents;
